import { AlertTriangle, Inbox, LoaderCircle, RefreshCw } from 'lucide-react';
import type { ReactNode } from 'react';
import { Button, Card, cn } from './primitives';

export function LoadingScreen({ label = 'Caricamento…' }: { label?: string }) {
  return (
    <div className="dd-loading" role="status">
      <LoaderCircle className="dd-spin" aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}

export function Skeleton({ className }: { className?: string }) {
  return <span className={cn('dd-skeleton', className)} aria-hidden="true" />;
}

export function EmptyState({
  title,
  description,
  action,
  icon
}: {
  title: string;
  description: string;
  action?: ReactNode;
  icon?: ReactNode;
}) {
  return (
    <Card className="dd-empty-state">
      <div className="dd-empty-icon">{icon ?? <Inbox aria-hidden="true" />}</div>
      <h2>{title}</h2>
      <p>{description}</p>
      {action}
    </Card>
  );
}

export function ErrorState({
  title = 'Impossibile caricare i dati',
  message,
  onRetry
}: {
  title?: string;
  message: string;
  onRetry?: () => void;
}) {
  return (
    <Card className="dd-error-state" role="alert">
      <AlertTriangle aria-hidden="true" />
      <div>
        <h2>{title}</h2>
        <p>{message}</p>
      </div>
      {onRetry ? (
        <Button variant="secondary" onClick={onRetry}>
          <RefreshCw size={16} /> Riprova
        </Button>
      ) : null}
    </Card>
  );
}
